import { render, staticRenderFns } from "./UpcomingBookings.vue?vue&type=template&id=14cb2b22"
import script from "./UpcomingBookings.vue?vue&type=script&lang=js"
export * from "./UpcomingBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports